import { Create, SimpleForm, TextInput, required } from "react-admin";

export const cityCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" fullWidth validate={required()}/>
      <TextInput source="code_postal" fullWidth  validate={required()}/>
    </SimpleForm>
  </Create>
);
